import "../App.css"
import ProjectItems from '../data/Projects';
import ProjectCards from "./ProjectCards";

function Projects({projectsRef}){
    return (
        <div className="Projects" ref={projectsRef}>
            <h1>Projects</h1>
            <div className="Projects-Container">
                {ProjectItems.map(project => <ProjectCards key={project.id} data={project} />)}
            </div>
        </div>
    )
}

export default Projects;